// extracted by mini-css-extract-plugin
export default {"root":"wqd5WusN4uDfMo28zfg_","expired-page":"geCvMSD7Hcg5PJ0mmK6b"};